import { defineMessages } from 'react-intl';

export const scope = 'app.components.EarningsTrendChart';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Earnings Trend'
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage: 'Your tipping activity over time'
  },
  sevenDays: {
    id: `${scope}.seven_days`,
    defaultMessage: '7D'
  },
  thirtyDays: {
    id: `${scope}.thirty_days`,
    defaultMessage: '30D'
  },
  today: {
    id: `${scope}.today`,
    defaultMessage: 'Today'
  },
  noData: {
    id: `${scope}.no_data`,
    defaultMessage: 'No tips in this period yet — share your tip link to get started'
  }
});
